import {
  Box,
  Heading,
  IconInfo,
  Inline,
  Stack,
  Text,
  TooltipRenderer,
} from 'braid-design-system';

type SalaryRangeInfoProps = {
  description: string;
  salaryPeriod: string;
  salaryRange: string;
  tooltipText: string;
};

export const SalaryRangeInfo = ({
  salaryRange,
  salaryPeriod,
  description,
  tooltipText,
}: SalaryRangeInfoProps) => {
  return (
    <Box paddingY="large" paddingX={['medium', 'large']}>
      <Stack space="medium" align="left">
        <Inline alignY="center" space="xxsmall">
          <Heading level="3">{salaryRange}</Heading>
          <Text>{salaryPeriod}</Text>
        </Inline>
        <Text tone="neutral">
          {description}
          <TooltipRenderer
            placement="bottom"
            tooltip={<Text>{tooltipText}</Text>}
          >
            {({ triggerProps }) => (
              <Box component="span" paddingLeft="xxsmall" {...triggerProps}>
                <IconInfo tone="neutral" />
              </Box>
            )}
          </TooltipRenderer>
        </Text>
      </Stack>
    </Box>
  );
};
